<!-- https://www.npmjs.com/package/vue-numeric -->
<template>
  <div
    :class="[
      readonly && label == ''
        ? ''
        : 'v-input v-text-field v-input--is-dirty v-input--is-readonly theme--light}'
    ]"
  >
    <div :class="[readonly && label == '' ? '' : 'v-input__control']">
      <div :class="[readonly && label != '' ? '' : 'v-input__slot']">
        <div :class="[readonly ? 'inverso' : 'v-text-field__slot']">
          <label
            aria-hidden="true"
            class="v-label v-label--active theme--light"
            style="left: 0px; right: auto; position: absolute;"
            >{{ label }}</label
          >
          <VueNumeric
            :id="id"
            :value="value"
            :min="min"
            :max="max"
            :currency="currency"
            :decimal-separator="separatorDecimal"
            :thousand-separator="separatorThousand"
            :precision="precision"
            :read-only="readonly"
            currency-symbol-position="suffix"
            class="numerico"
            @input="actualizarCampo($event)"
            @keyup.native="onKeydown"
            @blur="salir"
            read-only-class="numericRead"
            :minus="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric';

export default {
  name: 'Numeric',
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: -9999999999
    },
    max: {
      type: Number,
      default: 9999999999
    },
    currency: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: 2
    },
    label: {
      type: String,
      default: ''
    }
  },
  components: {
    VueNumeric
  },
  data: () => ({
    separatorThousand: '.',
    separatorDecimal: ','
  }),
  methods: {
    actualizarCampo(valor) {
      this.$emit('input', valor);
    },
    onKeydown(e) {
      var key = e.which || e.keyCode;
      if (key === 110 || key === 190) {
        this.separatorDecimal = '.';
        this.separatorThousand = ',';
      }
    },
    salir() {
      this.separatorDecimal = ',';
      this.separatorThousand = '.';
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.numerico {
  text-align: right;
}

.numericRead {
  padding: 4px 0;
}

.inverso {
  flex-direction: row-reverse;
  display: flex;
  flex: 1 1 auto;
  position: relative;
}
</style>
